// Events legacy conservés hors périmètre du plan de marquage AE : les étapes du tunnel passent
// désormais par `AeTrackingEvents` (app/constants/loanAeTracking.ts).
// Same GTM event names as the Vue/Symfony enum `assets/js/enum/loan/LoanTrackingEnum.js`.
export const LoanTrackingEvents = {
    identity: {
        coldLeadSent: 'gads_loan.identity_gateway_page.cold_lead_sent',
        whatsappCheckboxClicked: 'gtm_loan.coordonnees_pret_immobilier.whatsapp_checkbox_clicked',
        legalCheckboxClicked: 'gtm_loan.coordonnees_pret_immobilier.legale_checkbox_clicked',
    },
    results: {
        ctaBack: 'gtm_loan.results_page.back_cta_clicked',
        ctaHelp: 'gtm_loan.results_page.help_cta_clicked',
        // Absent de l'enum Vue : CTA « Prendre rendez-vous » des cartes, tag GTM à créer.
        ctaCallback: 'gtm_loan.results_page.callback_cta_clicked',
    },
    offerNav: {
        ctaQuotation: 'gtm_loan.results_page.devis_cta_clicked',
        ctaSchedule: 'gtm_loan.results_page.monthly_cta_clicked',
    },
    offerModal: {
        pageview: 'gtm_loan.devis_modale.pageview',
        submitForm: 'gtm_loan.devis_modale.form_submit',
    },
    subscriptionModal: {
        submitForm: 'gtm_loan.subscription_modale.form_submit',
    },
    subscription: {
        pageview: 'gtm_loan.subscription_page.pageview',
        ctaSubscribe: 'gtm_loan.subscription_page.subscription_cta_clicked',
        submitForm: 'gtm_loan.subscription_page.form_submit',
        whatsappSwitchToggled: 'gtm_loan.adhesion-assurance-pret-immobilier.whatsapp_switch_toggled',
        callSwitchToggled: 'gtm_loan.adhesion-assurance-pret-immobilier.call_switch_toggled',
    },
    // Conversions: `gtm` = named GA4 event (identity + subscription); `lead` = the BARE event
    // the Google Ads tag listens to (results page). Do not rename: GTM triggers depend on these.
    conversion: {
        gtm: 'gtm_loan.conversion',
        lead: 'conversion',
    },
} as const
